/**
 * example message:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645478797694,
	"notificationDetails": {"updateType":"EXIT_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"trailAmount":0.25},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"GRAB_CENTS","symbol":"XYZ"},
	"date": "2022-02-21T16:26:38.339-0500",
	"timestamp": "1645478798341"
}

 * @param {*} pluginTemplate 
 * @returns object with field:
 * 1) trailAmount
 */
export function grabCentsParser(pluginTemplate) {
    const parsedObject = {
        trailAmount: null,
    }
    if(pluginTemplate) {
        parsedObject.trailAmount=pluginTemplate.trailAmount;
    }
    return parsedObject;
}